import "ngstorage";

import {REFERENCE_SCREENS} from "../../variables";
import {TRIGGER_NEXT_EVENT_NAME, UPDATE_WORKFLOW_EVENT_NAME} from "../../../postashiftwalkthrough/variables";

class WelcomescreenController {
  constructor($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
    this.name = "welcomescreen";
    //this.walkthroughState = WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS;

    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;
    this.referenceScreens = REFERENCE_SCREENS;
  }

  $onInit() {
    console.log("welcome screen");
    console.dir(this);
  }

  goNext() {
    this.$timeout(() => {
      this.$rootScope.$emit("SendToNextReferenceScreen", {
        referenceScreen: this.referenceScreens.WELCOME_SCREEN,
      });
    });
  }
}

WelcomescreenController.$inject = [
  "$localStorage",
  "$rootScope",
  "$scope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "tracking",
  "events",
];

export default WelcomescreenController;



// WEBPACK FOOTER //
// ./client/app/scenes/references/scenes/welcomescreen/welcomescreen.controller.js